<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card class="my-4" height="100%" width="100%">
                    <v-card-title class="d-flex align-center justify-space-between">
                        <div>
                            <span>Στοιχεία σύμβασης</span>
                            <span v-if="contract.id" style="font-weight: bold;">&nbsp; {{ contract.title }}</span>
                        </div>
                        <v-btn 
                            color="primary" 
                            rounded 
                            elevation="2" 
                            small 
                            class="px-3 font-weight-bold white--text"
                            @click="showEditContractDialog"
                        >
                            <v-icon left size="18">mdi-pencil</v-icon>
                            <span>ΕΠΕΞΕΡΓΑΣΙΑ</span>
                        </v-btn>
                    </v-card-title>
                    
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-text-field label="Πελάτης" v-bind:value="contract.customer_name" readonly> </v-text-field>
                                <v-text-field label="Ημ/νία έναρξης" v-bind:value="contract.start_date" readonly> </v-text-field>
                                <v-text-field 
                                    label="Ημ/νία λήξης" 
                                    v-bind:value="contract.end_date" 
                                    readonly
                                    append-icon="mdi-pencil"
                                    @click:append="showEditContractDialog"
                                    style="cursor: pointer;"
                                > </v-text-field>
                            </v-col>
                        
                            <v-col>
                                <v-text-field 
                                    label="Ποσό σύμβασης" 
                                    v-bind:value="contract.total_amount" 
                                    readonly
                                    append-icon="mdi-pencil"
                                    @click:append="showEditContractDialog"
                                    style="cursor: pointer;"
                                > </v-text-field>
                                <v-text-field label="Τιμολογημένα (καθαρά)" v-bind:value="totalsSum('invoices', 'net_amount', 2)" readonly> </v-text-field>
                                <v-text-field label="Τιμολογημένα (μικτά)" v-bind:value="totalsSum('invoices', 'amount', 2)" readonly> </v-text-field>
                                
                            </v-col>

                            <v-col>
                                <v-text-field label="Επόμενη τιμολόγηση" v-bind:value="nextInstallmentDate" readonly> </v-text-field>
                                <v-text-field label="Ποσό τιμολόγησης" v-bind:value="nextInstallmentAmount" readonly> </v-text-field>
                                <v-text-field label="Εισπραχθέντα" v-bind:value="totalsSum('payments', 'amount', 2)" readonly> </v-text-field>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>

                <v-dialog v-model="dialogEditContract" max-width="480px" persistent>
                    <v-card>
                        <v-card-title class="text-h5 primary white--text d-flex align-center">
                            <v-icon left color="white">mdi-pencil</v-icon>
                            <span>Επεξεργασία Σύμβασης</span>
                        </v-card-title>
                        <v-card-text class="pt-4">
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="editContractData.title"
                                            label="Τίτλος σύμβασης"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-menu
                                            v-model="menuContractStartDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="editContractData.start_date"
                                                    label="Ημερομηνία έναρξης"
                                                    append-icon="mdi-calendar"
                                                    readonly
                                                    outlined
                                                    dense
                                                    v-bind="attrs"
                                                    v-on="on">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="editContractData.start_date"
                                                @input="menuContractStartDate = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-menu
                                            v-model="menuContractEndDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="editContractData.end_date"
                                                    label="Ημερομηνία λήξης"
                                                    append-icon="mdi-calendar"
                                                    readonly
                                                    outlined
                                                    dense
                                                    v-bind="attrs"
                                                    v-on="on">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="editContractData.end_date"
                                                @input="menuContractEndDate = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <vuetify-money
                                            label="Ποσό σύμβασης"
                                            v-model="editContractData.total_amount"
                                            v-bind:options="moneyFieldOptions"
                                        ></vuetify-money>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="pb-4 px-4">
                            <v-spacer></v-spacer>
                            <v-btn color="grey darken-1" text @click="dialogEditContract = false" :disabled="savingContract">ΑΚΥΡΟ</v-btn>
                            <v-btn 
                                color="primary" 
                                rounded 
                                elevation="2" 
                                class="px-4 font-weight-bold" 
                                @click="saveContractChanges" 
                                :loading="savingContract"
                            >
                                ΑΠΟΘΗΚΕΥΣΗ
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>

            <v-col>
                <v-card class="my-4" height="100%" width="100%">
                    <v-card-title>Αρχεία σύμβασης <span v-if="showFilesCount" class="mx-2"> ({{ contractFilesCount }})</span>
                        <v-spacer/>
                        <v-btn text color="primary" @click="showAddFileDialog">ΠΡΟΣΘΗΚΗ</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-list-item two-line v-for="file in contract.files" :key="file.id">
                                <v-list-item-icon>
                                    <v-progress-circular indeterminate v-if="file.is_being_deleted"></v-progress-circular>
                                    <v-icon @click="deleteFile(file)" v-else> mdi-delete </v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title><a v-bind:href="getLink(file)" target="_new">{{file.original_file_name}}</a></v-list-item-title>
                                    <v-list-item-subtitle>Αποθήκευση: {{ getHumanDate(file.created_at) }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>    
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-dialog v-model="addFileDialog" max-width="350px">
                    <v-card>
                        <v-card-text>
                            <file-uploader title="Επιλογή αρχείου" filter=".pdf" v-bind:target="contractFilesUrl"></file-uploader>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="my-4">
                    <v-card-title>
                        <template>
                            <span>Πρόγραμμα τιμολόγησης</span>
                            <v-spacer/>
                            <v-btn 
                                color="success" 
                                rounded 
                                elevation="2" 
                                class="m-2 px-4 font-weight-bold white--text" 
                                @click="showCalculateScheduleDialog"
                            >
                                <v-icon left size="20">mdi-calculator</v-icon>
                                <span>ΥΠΟΛΟΓΙΣΜΟΣ ΠΡΟΓΡΑΜΜΑΤΟΣ</span>
                            </v-btn>
                            <v-btn 
                                color="primary" 
                                rounded 
                                elevation="2" 
                                class="m-2 px-4 font-weight-bold white--text" 
                                @click="showAddItemDialog"
                            >
                                <v-icon left size="20">mdi-plus</v-icon>
                                <span>ΝΕΟ</span>
                            </v-btn> 
                        </template>
                    </v-card-title>
                    
                    <v-card-text>
                        <v-data-table
                            :headers="scheduleTableHeaders"
                            :items="installments"
                            :loading="loading"
                            loading-text="Φόρτωση προγράμματος..."
                            no-data-text="Δεν υπάρχουν δεδομένα"
                            :item-class="tableRowClassGenerator"
                            :sort-by="['due_date', 'amount']"
                            class="elevation-1"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :disable-filtering="true"
                            :hide-default-footer="true">

                                <template slot="top">
                                    <v-dialog v-model="dialogDelete" max-width="350px">
                                        <v-card>
                                            <v-card-title class="text-h5">Διαγραφή εγγραφής</v-card-title>
                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-text-field readonly label="Ποσό" v-bind:value="`€ ${editedItem.amount}`"></v-text-field>
                                                    </v-row>
                                                    <v-row>
                                                        <v-text-field readonly label="Ημερομηνία" v-bind:value="editedItem.scheduled_date"></v-text-field>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="warning darken-1" text @click="closeDeleteItemDialog">ΑΚΥΡΟ</v-btn>
                                                <v-btn color="error darken-1" text @click="deleteScheduleItem(editedItem)">ΕΝΤΑΞΕΙ</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                    <v-dialog v-model="dialogEdit" max-width="350px" >
                                        <v-card>
                                            <v-card-title class="text-h5">Επεξεργασία εγγραφής</v-card-title>
                                            <v-card-text>
                                                <vuetify-money label="Ποσό" v-model="editedItem.amount"></vuetify-money>
                                                <v-menu
                                                    v-model="menu2"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="editedItem.scheduled_date_iso"
                                                            label="Ημερομηνία"
                                                            append-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on">
                                                        </v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="editedItem.scheduled_date_iso"
                                                        @input="menu2 = false">
                                                    </v-date-picker>
                                                </v-menu>  
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="warning darken-1" text @click="closeEditItemDialog">ΑΚΥΡΟ</v-btn>
                                                <v-btn color="error darken-1" text @click="updateScheduleItem(editedItem)">ΕΝΤΑΞΕΙ</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                    <v-dialog v-model="dialogCreate" max-width="350px" >
                                        <v-card>
                                            <v-card-title class="text-h5">Δημιουργια εγγραφής</v-card-title>
                                            <v-card-text>
                                                <vuetify-money label="Ποσό" v-model="editedItem.amount"></vuetify-money>
                                                <v-menu
                                                    v-model="menu2"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="editedItem.scheduled_date_iso"
                                                            label="Ημερομηνία έκδοσης"
                                                            append-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on">
                                                        </v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="editedItem.scheduled_date_iso"
                                                        @input="menu2 = false">
                                                    </v-date-picker>
                                                </v-menu>        
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="warning darken-1" text @click="closeAddItemDialog">ΑΚΥΡΟ</v-btn>
                                                <v-btn color="error darken-1" text @click="addScheduleItem(editedItem)">ΕΝΤΑΞΕΙ</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                    <v-dialog v-model="dialogCalculateSchedule" max-width="680px" persistent>
                                        <v-card>
                                            <v-card-title class="text-h5 primary white--text d-flex align-center">
                                                <v-icon left color="white">mdi-calculator</v-icon>
                                                <span>Υπολογισμός Προγράμματος Τιμολόγησης</span>
                                            </v-card-title>
                                            <v-card-text class="pt-4">
                                                <v-container>
                                                    <v-row dense>
                                                        <v-col cols="12" sm="6">
                                                            <v-select
                                                                v-model="calcScheduleForm.frequency"
                                                                :items="frequencyOptions"
                                                                label="Συχνότητα τιμολόγησης"
                                                                outlined
                                                                dense
                                                                @change="onScheduleConfigChange"
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" v-if="calcScheduleForm.frequency !== 'weekly'">
                                                            <v-select
                                                                v-model="calcScheduleForm.billing_day"
                                                                :items="billingDayMonthOptions"
                                                                label="Ημέρα τιμολόγησης"
                                                                outlined
                                                                dense
                                                                @change="onScheduleConfigChange"
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" v-else>
                                                            <v-select
                                                                v-model="calcScheduleForm.billing_day"
                                                                :items="billingDayWeekOptions"
                                                                label="Ημέρα εβδομάδας"
                                                                outlined
                                                                dense
                                                                @change="onScheduleConfigChange"
                                                            ></v-select>
                                                        </v-col>
                                                    </v-row>

                                                    <v-alert
                                                        v-if="schedulePreview && schedulePreview.invoiced_count > 0"
                                                        type="info"
                                                        text
                                                        dense
                                                        class="mb-3"
                                                    >
                                                        <strong>Υπάρχουν {{ schedulePreview.invoiced_count }} τιμολογημένες δόσεις</strong> (Σύνολο: € {{ Number(schedulePreview.invoiced_sum).toFixed(2) }}), οι οποίες παραμένουν ανέπαφες.<br/>
                                                        Το νέο πρόγραμμα θα επιμερίσει το υπολειπόμενο ποσό <strong>€ {{ Number(schedulePreview.remaining_amount).toFixed(2) }}</strong> σε {{ schedulePreview.installments_count }} νέες δόσεις.
                                                    </v-alert>

                                                    <v-row dense class="mb-2" v-if="schedulePreview">
                                                        <v-col cols="6" sm="4">
                                                            <v-card outlined class="pa-2 text-center">
                                                                <div class="caption grey--text">Σύνολο Σύμβασης</div>
                                                                <div class="subtitle-2 font-weight-bold">€ {{ Number(schedulePreview.total_amount).toFixed(2) }}</div>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col cols="6" sm="4">
                                                            <v-card outlined class="pa-2 text-center">
                                                                <div class="caption grey--text">Ποσό Κατανομής</div>
                                                                <div class="subtitle-2 font-weight-bold primary--text">€ {{ Number(schedulePreview.remaining_amount).toFixed(2) }}</div>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col cols="12" sm="4">
                                                            <v-card outlined class="pa-2 text-center">
                                                                <div class="caption grey--text">Πλήθος Νέων Δόσεων</div>
                                                                <div class="subtitle-2 font-weight-bold success--text">{{ schedulePreview.installments_count }} δόσεις</div>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>

                                                    <div class="subtitle-2 font-weight-bold mb-1">Προεπισκόπηση Νέων Δόσεων:</div>
                                                    <v-card outlined max-height="240px" style="overflow-y: auto;">
                                                        <v-simple-table dense>
                                                            <template v-slot:default>
                                                                <thead>
                                                                    <tr>
                                                                        <th class="text-left">#</th>
                                                                        <th class="text-left">Ημερομηνία</th>
                                                                        <th class="text-right">Ποσό (€)</th>
                                                                        <th class="text-center">Σημείωση</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(inst, idx) in (schedulePreview ? schedulePreview.preview : [])" :key="idx">
                                                                        <td>{{ idx + 1 }}</td>
                                                                        <td>{{ inst.scheduled_date }}</td>
                                                                        <td class="text-right font-weight-bold">€ {{ Number(inst.amount).toFixed(2) }}</td>
                                                                        <td class="text-center caption grey--text">
                                                                            <span v-if="idx === schedulePreview.preview.length - 1 && schedulePreview.preview.length > 1">Κλείσιμο στρογγυλοποίησης</span>
                                                                            <span v-else>-</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-if="!schedulePreview || !schedulePreview.preview || schedulePreview.preview.length === 0">
                                                                        <td colspan="4" class="text-center grey--text py-3">Δεν παρήχθησαν δόσεις για τις επιλεγμένες ρυθμίσεις.</td>
                                                                    </tr>
                                                                </tbody>
                                                            </template>
                                                        </v-simple-table>
                                                    </v-card>
                                                    <div class="caption grey--text mt-1">
                                                        * Η διαίρεση γίνεται ισόποσα με στρογγυλοποίηση στα 2 δεκαδικά, και τυχόν δεκαδική διαφορά κλείνει στην τελευταία δόση.
                                                    </div>
                                                </v-container>
                                            </v-card-text>
                                            <v-card-actions class="pb-4 px-4">
                                                <v-spacer></v-spacer>
                                                <v-btn color="grey darken-1" text @click="dialogCalculateSchedule = false" :disabled="calculatingSchedule">ΑΚΥΡΟ</v-btn>
                                                <v-btn 
                                                    color="success" 
                                                    rounded 
                                                    elevation="2" 
                                                    class="px-4 font-weight-bold white--text" 
                                                    @click="applyCalculatedSchedule" 
                                                    :loading="calculatingSchedule"
                                                    :disabled="!schedulePreview || !schedulePreview.preview || schedulePreview.preview.length === 0"
                                                >
                                                    ΕΦΑΡΜΟΓΗ ΠΡΟΓΡΑΜΜΑΤΟΣ
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                </template>

                                
                                <template slot="body.append">
                                    <tr>
                                        <th>Σύνολο</th>
                                        <th class="text-right">{{totalsSum('installments', 'amount', 2)}}</th>
                                    </tr>
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-icon v-if="item.is_invoiced == false" small @click="showEditItemDialog(item)" class="mr-2" > mdi-pencil </v-icon>
                                    <v-icon v-if="item.is_invoiced == false" small @click="showDeleteItemDialog(item)"> mdi-delete </v-icon>
                                </template>
                            </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card class="my-4">
                    <v-card-title>Τιμολόγια</v-card-title>
                    
                    <v-card-text>
                        <v-data-table
                            :headers="invoicesTableHeaders"
                            :items="invoices"
                            :loading="loading"
                            loading-text="Φόρτωση τιμολογίων..."
                            no-data-text="Δεν υπάρχουν τιμολόγια"
                            :item-class="tableRowClassGenerator"
                            :sort-by="['due_date', 'amount']"
                            class="elevation-1"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :disable-filtering="true"
                            :hide-default-footer="true">
                            <template slot="body.append">
                                <tr>
                                    <th>Σύνολο</th>
                                    <th></th>
                                    <th class="text-right">{{totalsSum('invoices', 'net_amount', 2)}}</th>
                                    <th class="text-right">{{totalsSum('invoices', 'amount', 2)}}</th>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card class="my-4">
                    <v-card-title>Εισπράξεις</v-card-title>
                    
                    <v-card-text>
                        <v-data-table
                            :headers="paymentsTableHeaders"
                            :items="payments"
                            :loading="loading"
                            loading-text="Φόρτωση εισπράξεων..."
                            no-data-text="Δεν υπάρχουν εισπράξεις"
                            :item-class="tableRowClassGenerator"
                            :sort-by="['due_date', 'amount']"
                            class="elevation-1"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :disable-filtering="true"
                            :hide-default-footer="true"
                            >
                            <template slot="body.append">
                                <tr>
                                    <th>Σύνολο</th>
                                    <th></th>
                                    <th class="text-right">{{totalsSum('payments', 'amount', 2)}}</th>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        
    </v-container>
    
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    components: {
    },
    
    data() {
        return {
            loading: true,

            contract: {},

            installments: [],
            invoices: [],
            payments: [],

            nextInstallment: {},
                
            scheduleTableHeaders: [
                {
                    'text' : 'Ημερομηνία',   
                    'value' : 'scheduled_date'
                },
                {
                    'text' : 'Ποσό τιμολόγησης',
                    'value' : 'amount',
                    'align' : 'right'
                },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            
            invoicesTableHeaders: [
                {
                    'text' : 'Ημερομηνία',   
                    'value' : 'issue_date'
                },
                {
                    'text' : 'Παραστατικό',   
                    'value' : 'document'
                },
                {
                    'text' : 'Καθαρό ποσό',
                    'value' : 'net_amount',
                    'align' : 'right'
                },
                {
                    'text' : 'Μικτό ποσό',
                    'value' : 'amount',
                    'align' : 'right'
                }
            ],

            paymentsTableHeaders: [
                {
                    'text' : 'Ημερομηνία',   
                    'value' : 'issue_date'
                },
                {
                    'text' : 'Παραστατικό',   
                    'value' : 'document'
                },
                {
                    'text' : 'Ποσό είσπραξης',
                    'value' : 'amount',
                    'align' : 'right'
                }
            ],

            editedItem: {},

            dialogDelete: null,
            dialogEdit: null,
            dialogCreate: null,

            menu2: false,

            addFileDialog: false,
            uploading: false,

            dialogEditContract: false,
            savingContract: false,
            menuContractStartDate: false,
            menuContractEndDate: false,
            editContractData: {
                title: '',
                start_date: '',
                end_date: '',
                total_amount: 0
            },
            moneyFieldOptions: {
                locale: "el-GR",
                prefix: "€",
                suffix: "",
                length: 10,
                precision: 2
            },

            dialogCalculateSchedule: false,
            calculatingSchedule: false,
            calcScheduleForm: {
                frequency: 'monthly',
                billing_day: 'end_of_month'
            },
            schedulePreview: null,
            frequencyOptions: [
                { text: 'Κάθε Μήνα (Μηνιαία)', value: 'monthly' },
                { text: 'Κάθε Τρίμηνο (3 μήνες)', value: 'quarterly' },
                { text: 'Κάθε Εξάμηνο (6 μήνες)', value: 'semi_annually' },
                { text: 'Κάθε Χρόνο (Ετήσια)', value: 'annually' },
                { text: 'Κάθε Εβδομάδα (Εβδομαδιαία)', value: 'weekly' }
            ],
            billingDayMonthOptions: [
                { text: 'Τέλος Μήνα', value: 'end_of_month' },
                { text: '1η του μήνα', value: '1' },
                { text: '5η του μήνα', value: '5' },
                { text: '10η του μήνα', value: '10' },
                { text: '15η του μήνα', value: '15' },
                { text: '20ή του μήνα', value: '20' },
                { text: '25η του μήνα', value: '25' },
                { text: '30ή του μήνα', value: '30' }
            ],
            billingDayWeekOptions: [
                { text: 'Ημέρα έναρξης σύμβασης', value: 'start_day' },
                { text: 'Κάθε Δευτέρα', value: '1' },
                { text: 'Κάθε Τρίτη', value: '2' },
                { text: 'Κάθε Τετάρτη', value: '3' },
                { text: 'Κάθε Πέμπτη', value: '4' },
                { text: 'Κάθε Παρασκευή', value: '5' },
                { text: 'Κάθε Σάββατο', value: '6' },
                { text: 'Κάθε Κυριακή', value: '7' }
            ],
        }
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            this.loading = true;
            axios.get('/api/contracts/' + this.$route.params.id)
            .then(response => {
                this.contract = response.data.data
                this.installments = response.data.data.installments.sort((a, b) => a.scheduled_date_iso.localeCompare(b.scheduled_date_iso));
                this.invoices = response.data.data.invoices;
                this.payments = response.data.data.payments;
                this.nextInstallment = response.data.data.next_installment
            })
            .catch(error => console.log(error)).finally(() => { this.loading = false; })
            
        },

        showEditContractDialog() {
            this.editContractData = {
                title: this.contract.title || '',
                start_date: this.contract.start_date_iso || (this.contract.start_date ? moment(this.contract.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : ''),
                end_date: this.contract.end_date_iso || (this.contract.end_date ? moment(this.contract.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : ''),
                total_amount: this.contract.total_amount_raw != null ? this.contract.total_amount_raw : 0
            };
            this.dialogEditContract = true;
        },

        saveContractChanges() {
            this.savingContract = true;
            axios.patch('/api/contracts/' + this.contract.id, {
                title: this.editContractData.title,
                start_date: this.editContractData.start_date,
                end_date: this.editContractData.end_date,
                total_amount: this.editContractData.total_amount
            })
            .then(response => {
                this.dialogEditContract = false;
                this.savingContract = false;
                if (this.$swal) {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Επιτυχία',
                        text: 'Η σύμβαση ενημερώθηκε επιτυχώς.',
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
                this.initialize();
            })
            .catch(error => {
                this.savingContract = false;
                const msg = error.response?.data?.message || 'Παρουσιάστηκε σφάλμα κατά την ενημέρωση της σύμβασης.';
                if (this.$swal) {
                    this.$swal.fire('Σφάλμα', msg, 'error');
                } else {
                    alert(msg);
                }
            });
        },

        showCalculateScheduleDialog() {
            this.calcScheduleForm = {
                frequency: this.contract.billing_frequency || 'monthly',
                billing_day: this.contract.billing_day || 'end_of_month'
            };
            this.dialogCalculateSchedule = true;
            this.fetchSchedulePreview();
        },

        onScheduleConfigChange() {
            if (this.calcScheduleForm.frequency === 'weekly' && this.calcScheduleForm.billing_day === 'end_of_month') {
                this.calcScheduleForm.billing_day = 'start_day';
            } else if (this.calcScheduleForm.frequency !== 'weekly' && this.calcScheduleForm.billing_day === 'start_day') {
                this.calcScheduleForm.billing_day = 'end_of_month';
            }
            this.fetchSchedulePreview();
        },

        fetchSchedulePreview() {
            axios.post(`/api/contracts/${this.contract.id}/calculate-schedule`, {
                frequency: this.calcScheduleForm.frequency,
                billing_day: this.calcScheduleForm.billing_day,
                preview_only: true
            })
            .then(response => {
                this.schedulePreview = response.data;
            })
            .catch(error => {
                console.error(error);
            });
        },

        applyCalculatedSchedule() {
            this.calculatingSchedule = true;
            axios.post(`/api/contracts/${this.contract.id}/calculate-schedule`, {
                frequency: this.calcScheduleForm.frequency,
                billing_day: this.calcScheduleForm.billing_day,
                preview_only: false
            })
            .then(response => {
                this.dialogCalculateSchedule = false;
                this.calculatingSchedule = false;
                if (this.$swal) {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Επιτυχία',
                        text: 'Το πρόγραμμα τιμολόγησης υπολογίστηκε και ενημερώθηκε επιτυχώς.',
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
                this.initialize();
            })
            .catch(error => {
                this.calculatingSchedule = false;
                const msg = error.response?.data?.message || 'Παρουσιάστηκε σφάλμα κατά τον υπολογισμό του προγράμματος.';
                if (this.$swal) {
                    this.$swal.fire('Σφάλμα', msg, 'error');
                } else {
                    alert(msg);
                }
            });
        },

        uploadFileClicked() {
            console.log('Probably should upload the file...?')
        },

        showDeleteItemDialog (item) {
            // this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        closeDeleteItemDialog () {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                // this.editedIndex = -1
            })
        },

        showEditItemDialog (item) {
            // this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogEdit = true
        },


        closeEditItemDialog () {
            this.dialogEdit = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                // this.editedIndex = -1
            })
        },

        deleteScheduleItem(item) {
            axios.delete('/api/contract-installments/' + item.id)
            .then(() => {
                this.closeDeleteItemDialog()
                this.initialize()
            })
        },

        deleteFile(file) {

            const fileIndex = this.contract.files.indexOf(file)
            
            this.contract.files[fileIndex].is_being_deleted = true;
            
            axios.delete('/api/contract-files/' + file.id)
            .then(() => {
                this.initialize()
            })

        },

        showAddItemDialog() {
            this.editedItem = {
                amount: 0,
                scheduled_date_iso: moment().format('YYYY-MM-DD')
            }
            this.dialogCreate = true
        },

        closeAddItemDialog() {
            this.dialogCreate = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
            })
        },

        updateScheduleItem(item) {
            axios.patch('/api/contract-installments/' + item.id, {
                amount: item.amount,
                scheduled_date: item.scheduled_date_iso
            })
            .then(() => {
                this.closeEditItemDialog()
                this.initialize()
            })
        },
        
        addScheduleItem(item) {
            axios.post('/api/contract-installments', {
                contract_id: this.contract.id,
                amount: item.amount,
                scheduled_date: item.scheduled_date_iso
            })
            .then(() => {
                this.closeAddItemDialog()
                this.initialize()
            })
        },

        showAddFileDialog() {
            this.addFileDialog = true;
        },

        closeAddFileDialog() {
            this.addFileDialog = false;
        },

        totalsSum(tableData, fieldName, fixDecimals) {
            const sum = this[tableData].map(x => parseFloat(x[fieldName])).reduce((a, b) => a + b, 0)

            if (fixDecimals > 0)
                return sum.toFixed(2)

            return parseInt(sum)
        },

        tableRowClassGenerator(item) {

            if (item.is_invoiced)
                return 'green lighten-4'

            if (item.is_overdue)
                return 'red lighten-4'

        },

        getHumanDate(date) {
            return moment(date).format('DD/MM/YYYY HH:mm')
        },

        getLink(file) {
            return `/contract-files/${file.file_name}`
        },

        isBeingDeleted(file) {
            return file.is_being_deleted === true 
        }
    },

    computed: {
        showFilesCount() {
            return this.contract?.files?.length > 0
        },

        nextInstallmentDate() {
            return this.nextInstallment?.scheduled_date ?? "Δ/Υ"
        },

        nextInstallmentAmount() {
            return this.nextInstallment?.amount ?? "Δ/Υ"
        },

        contractFilesUrl() {
            return `/api/contracts/${this.contract.id}/files`
        },

        contractFilesCount() {
            return this.contract?.files?.length ?? 0
        },

   
    }
}
</script>
